import { gql } from "@/__generated__";

export const GET_SUPPORTING_DOCUMENTS_FOR_APPEAL = gql(`
  query GetSupportingDocumentsForAppeal($appealId: ID!) {
    getAppealById(appealId: $appealId) {
      supportingDocuments {
        documentId
        documentType
        uploadedBy
        otherDocumentTypeName
        files {
          fileId
          fileName
          fileType
          url
          pageCount
        }
      }
      referral {
        patientEmail
      }
      patient {
        firstName
        lastName
        dateOfBirth
      }
      denial {
        condition
        medicationBrandName
      }
    }
  }
`);

export const GENERATE_SUPPORTING_DOCUMENT_UPLOAD_URLS = gql(`
  mutation GenerateSupportingDocumentUploadUrls(
    $appealId: ID!
    $document: GenerateSupportingDocumentUploadInput!
  ) {
    generateSupportingDocumentUploadUrls(appealId: $appealId, document: $document) {
      documentId
      fileUploadDetails {
        fileId
        fileName
        uploadUrl
      }
    }
  }
`);

export const UPSERT_APPEAL_SUPPORTING_DOCUMENT = gql(`
  mutation UpsertAppealSupportingDocument(
    $appealId: ID!
    $document: PersistSupportingDocumentInput!
  ) {
    upsertAppealSupportingDocument(appealId: $appealId, document: $document) {
      document {
        documentId
        documentType
        uploadedBy
        otherDocumentTypeName
        files {
          fileId
          fileName
          fileType
          url
          pageCount
        }
      }
    }
  }
`);

export const DELETE_APPEAL_SUPPORTING_DOCUMENT = gql(`
  mutation DeleteAppealSupportingDocument($documentId: ID!) {
    deleteAppealSupportingDocument(documentId: $documentId)
  }
`);
